export const faq = {
    title: 'Câu hỏi thường gặp',
    titleStaking: ' Điều kiện để mua INO là gì?',
    subTitleStaking:
        'Để mua NFT theo vòng INO, bạn cần thực hiện các bước sau:<br> <br>' +
        '<b>Bước 1</b>: Download ứng dụng AIS tại:<br>' +
        "- Android: <a href=' https://ste.sbgroup.finance/apk/ste-app-release-v2.apk'> https://ste.sbgroup.finance/apk/ste-app-release-v2.apk</a><br>" +
        "- iOS: <a href='https://testflight.apple.com/join/xaFDhi6Y'>https://testflight.apple.com/join/xaFDhi6Y</a><br><br>" +
        '<b>Bước 2</b>: Người dùng thực hiện KYC theo hướng dẫn và sẽ nhận được xác nhận<br>' +
        'Chỉ những tài khoản đã xác minh KYC mới đủ điều kiện tham gia vòng INO.',
    titleStakingHold: '<b>2. Mua NFT được gì?</b>',
    subTitleStakingHold:
        'Khi mua NFT nguyên thủy với giá $250/NFT trong INO này, người chơi có thể kiếm được $15 chỉ với 3 phút tập thể dục mỗi ngày. ' +
        'Thời gian thu hồi vốn chỉ trong 20 ngày và kiếm được tới $450 trong 30 ngày.<br><br>' +
        'Ngoài ra, với cơ chế mint NFT cực kỳ hấp dẫn, từ 1 cặp NFT (nam + nữ) có thể tạo ra 7 NFT con.' +
        'Người chơi có thể ngay lập tức kiếm được ít nhất $2700/30 ngày một cách dễ dàng hoặc thậm chí nhiều hơn với 5 phút luyện tập thường xuyên mỗi ngày.<br>' +
        'Lợi nhuận thu được gấp nhiều lần số vốn ban đầu bạn đầu tư.<br><br>',
    titleStakingInformation: '<b>3. Token AIS là gì?</b>',
    subTitleStakingInformation:
        'AIS là token đại diện của Stretch-to-Earn, được liên kết với SB để tạo ra các tiện ích xung quanh ứng dụng này.<br>' +
        'Hãy cùng xem thông tin cơ bản về token AIS:<br>' +
        '- Kí hiệu: AIS<br>' +
        '- Tổng nguồn cung: 10.000.000',
    titleInterestAfter: '<b>4. Tôi có thể liên hệ trợ giúp với ai khi cần?</b>',
    subTitleInterestAfter: 'Mọi thắc mắc vui lòng liên hệ: <a>info@dragonsb.finance</a>',
    titleNotReceivingInterest: '<b>5. Tôi có thể tìm hiểu thêm về AIS ở đâu?</b>',
    subTitleNotReceivingInterest:
        'Vui lòng truy cập blog của chúng tôi để biết thêm về AIS<br>' +
        '- Giới thiệu về $AIS: <a href="https://blog.dragonsb.finance/ste-the-heart-of-stretch-to-earn/">https://blog.dragonsb.finance/ste-the-heart-of-stretch-to-earn/</a><br>' +
        '- Về cơ chế và nền kinh tế của AIS: <a href="https://blog.dragonsb.finance/a-super-rare-chance-to-hunt-nft-from-hot-trend-stretch-to-earn/"> https://blog.dragonsb.finance/a-super-rare-chance-to-hunt-nft-from-hot-trend-stretch-to-earn/</a><br>',
};
